/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unique_Group_NamesInputs */



/**
* | output |
* | --- |
* | "Group names must be unique" |
*
* @param {Unique_Group_NamesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unique_group_names = /** @type {((inputs?: Unique_Group_NamesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unique_Group_NamesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Group names must be unique")
	return /** @type {LocalizedString} */ ("Les noms de groupe doivent être uniques")
});